export default "__VITE_ASSET__LK4CUQY3__"